export default __webpack_public_path__ + "media/images/home/slide_2024-2025_winter_sm-9e05f997da82352c1f06ed8c881b1680.jpg";